// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"BaseStyles_backdrop__1KNBR","label":"BaseStyles_label__35CF3"};